/**
 * @author liqiuqi
 * @date 2022 2022/6/25 16:18
 */

import { omniAxios } from "@/utils/axios";
import { config } from "@/utils/config";

// 获取推荐的订阅器
export function restAccountSubscriberRecommendGet({ keyword = "" }) {
  return omniAxios({
    url: config.restAccountSubscriberRecommendGetPath,
    method: "get",
    params: { keyword },
  });
}

// 查询用户订阅器数量和推荐订阅器是否创建
export function restAccountSubscriberRecommendQueryRecommendSubscriber() {
  return omniAxios({
    url: config.restAccountSubscriberRecommendQueryRecommendSubscriberPath,
    method: "get",
    params: {},
  });
}

// 生成订阅
export function restAccountTenderSubscribeCreateOrUpdateSubscriber(params) {
  return omniAxios({
    url: config.restAccountTenderSubscribeCreateOrUpdateSubscriberPath,
    method: "post",
    params,
  });
}

// 检查订阅器创建权限
export function restAccountCompanySpaceCheckSubscribeCreatePermission() {
  return omniAxios({
    url: config.restAccountCompanySpaceCheckSubscribeCreatePermissionPath,
    method: "get",
    params: {},
  });
}

// 订阅器剩余可创建数量
export function restApiAccountSubscribeLaveSubscriberCount() {
  return omniAxios({
    url: config.restApiAccountSubscribeLaveSubscriberCountPath,
    method: "get",
    params: {},
  });
}

// 拟建 审批 订阅结果列表
export function restAccountSubscribeSolrList(params) {
  return omniAxios({
    url: config.restAccountSubscribeSolrListPath,
    method: "get",
    params,
    cancelLastSameRequest: true,
  });
}

// 拟建 审批 导出
export function projectAndApprovalExportCheck(params) {
  return omniAxios({
    url: config.projectAndApprovalExportCheckPath,
    method: "post",
    params,
  });
}

//订阅排序方式
export function restAccountTenderSubscriberGetUserSubscribeSort(params) {
  return omniAxios({
    url: config.restAccountTenderSubscriberGetUserSubscribeSortPath,
    method: "get",
    params,
  });
}

//订阅明细
export function restAccountTenderSubscriberGetTenderSummaryType(params) {
  return omniAxios({
    url: config.restAccountTenderSubscriberGetTenderSummaryTypePath,
    method: "get",
    params,
  });
}

//订阅日志
export function restAccountTenderSubscriberDetaiClicklog(params) {
  return omniAxios({
    url: config.restAccountTenderSubscriberDetaiClicklogPath,
    method: "get",
    params,
  });
}

//订阅满意度调查
export function restAccountSubscribeSatisfactionLogInsert(params) {
  return omniAxios({
    url: config.restAccountSubscribeSatisfactionLogInsertPath,
    method: "post",
    params,
    isFormData: true,
  });
}

//订阅满意度调查
export function restAccountSubscribeSatisfactionLogAboutTimeReturnChoose(params) {
  return omniAxios({
    url: config.restAccountSubscribeSatisfactionLogAboutTimeReturnChoosePath,
    method: "get",
    params,
  });
}

// 订阅器每一个关键词列表数量统计
export function restAccountSubscribeSolrListCount({
  areaIds,
  beginAmount,
  biddingType,
  businessIds,
  contentIdList,
  dateType,
  endAmount,
  endTime,
  exportKeyword,
  exportSource,
  exportType,
  fieldType,
  fundsSourceList,
  hasAgent,
  hasAnnex,
  hasLinkName,
  hasPhone,
  hitWord,
  keyword,
  noticeSegmentTypeStr,
  onlyCompanyMonitor,
  page,
  progIdAndNoticeSegmentTypeMaps,
  progIds,
  purchasingUnit,
  purchasingUnitIdList,
  registrationStatus,
  rows,
  sortType,
  startTime,
  subscribeId,
  subscribeIndex,
  subscribeType,
  summaryType,
  tenderOrBidderName,
  threeClassifyTagStr,
}) {
  return omniAxios({
    url: config.restAccountSubscribeSolrListCountPath,
    method: "post",
    params: {
      areaIds,
      beginAmount,
      biddingType,
      businessIds,
      contentIdList,
      dateType,
      endAmount,
      endTime,
      exportKeyword,
      exportSource,
      exportType,
      fieldType,
      fundsSourceList,
      hasAgent,
      hasAnnex,
      hasLinkName,
      hasPhone,
      hitWord,
      keyword,
      noticeSegmentTypeStr,
      onlyCompanyMonitor,
      page,
      progIdAndNoticeSegmentTypeMaps,
      progIds,
      purchasingUnit,
      purchasingUnitIdList,
      registrationStatus,
      rows,
      sortType,
      startTime,
      subscribeId,
      subscribeIndex,
      subscribeType,
      summaryType,
      tenderOrBidderName,
      threeClassifyTagStr,
    },
  });
}

// 保存排序方式 订阅
export function restAccountTenderSubscribeAddSubscribeSortType(params) {
  return omniAxios({
    url: config.restAccountTenderSubscribeAddSubscribeSortTypePath,
    method: "post",
    params,
    cancelLastSameRequest: true,
  });
}

// 获取新旧订阅器版本
export function restAccountSubscribeGrayGetVersion() {
  return omniAxios({
    url: config.restAccountSubscribeGrayGetVersionPath,
    method: "get",
    params: {},
  });
}

// 更新用户新旧版本订阅器
export function restAccountSubscribeGrayUpdateGray({ type }) {
  // 0：老版本  1：新版本
  return omniAxios({
    url: config.restAccountSubscribeGrayUpdateGrayPath,
    method: "get",
    params: {
      type,
    },
  });
}
